/* SurveyContainer.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./SurveyContainer.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { IconButton as Button } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/migration/cross';
import { N0, N50A, N60A } from '@atlaskit/theme/colors';
var containerStyles = null;
var buttonWrapperStyles = null;
export default (function (_ref) {
  var children = _ref.children,
    onDismiss = _ref.onDismiss;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_2rkofajl _bfhk13b4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _16qs1dt4 _1bsb1vif"]),
    style: {
      "--_1f6rtr1": ix("var(--ds-surface-overlay, ".concat(N0, ")")),
      "--_qzf6oc": ix("var(--ds-shadow-overlay, ".concat("0 20px 32px -8px ".concat(N50A, ", 0 0 1px ").concat(N60A), ")"))
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswstnw _154ipxbi _1xi2pxbi"])
  }, /*#__PURE__*/React.createElement(Button, {
    icon: CrossIcon,
    label: "Dismiss",
    appearance: "subtle",
    onClick: onDismiss
  })), children);
});